import styled from 'styled-components';

import { BACKGROUND_BTN_HOVER, BACKGROUND_BTN, PADDING_CONTENT_PAGE, HEIGHT_BTN, FONT_SIZE_BTN_ARROW, COLOR_BTN_HOVER, BACKGROUND_HEADER } from '../../../globals';


export const StyledBtnService = styled.div`
  height: 100%;

  .btn-service-container {
    padding: ${PADDING_CONTENT_PAGE}px;
    height: 100%;
  }

  .btn-service-content {
    display: block;
    background-color: ${BACKGROUND_BTN};
    padding: ${props => props.servicesGroups ? 10 : 15}px;
    cursor: pointer;
    ${props => props.servicesGroups ? '' : 'box-shadow: 1px 1px 2px rgb(171, 169, 169);'}
    border-radius: 2px;
    color: inherit;
    text-decoration: none;
    height: 100%;
   }

  .btn-service-content:hover, .btn-office-content:visited, .btn-office-content:active {
    text-decoration: none;
  }

  .btn-service-table {
    width: 100%;
    table-layout:fixed;
    font-size: 1em;
    min-height: 2.8em;
    line-height: 1.4em;
    height: 100%;
  }

  td, div {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .btn-service-content:hover {
    background-color: ${BACKGROUND_BTN_HOVER};
    color: ${COLOR_BTN_HOVER};
  }

  .btn-service-title {
    font-weight: bold;
    font-size: 1em;
    height: ${HEIGHT_BTN};
    word-break: normal;
  }

  .btn-service-arrow {
    width: 25px;
    text-align: center;
    vertical-align: middle;
    font-size: ${FONT_SIZE_BTN_ARROW}em;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .btn-service-content:focus {
    outline: 3px solid ${BACKGROUND_HEADER};
  }
`;



// WEBPACK FOOTER //
// ./src/common/BtnService/styles/StyledBtnService.js